import React, { FunctionComponent } from 'react';

import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface DefaultShareManifestsPrivateProps {
  defaultEnabled: boolean | null;
}

const DefaultShareManifestPrivate: FunctionComponent<DefaultShareManifestsPrivateProps> = ({ defaultEnabled }) => (
  <SettingsEnableDisable
    defaultEnabled={defaultEnabled}
    errorTitle={bfTranslate('Error updating default privacy of share links. Please contact support.')}
    id="default-share-manifests-private"
    successTitle={bfTranslate('Default privacy of share links updated.')}
    title={bfTranslate('Make share links private by default')}
    updateResourceKey="defaultShareManifestPrivate"
  />
);

export default DefaultShareManifestPrivate;
